import React from "react";

const Bash_Grep = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Bash Grep</h2>
      <p>Search text using patterns (regular expressions).</p>
      <h4 className="font-medium mt-4">Syntax</h4>
      <pre><code>grep [options] pattern [file...]</code></pre>
      <h4 className="font-medium mt-4">Examples</h4>
      <pre><code>grep TODO *.py
grep -R "main(" src/</code></pre>
      <h4 className="font-medium mt-4">Notes</h4>
      <p>Use -i for case-insensitive, -n to show line numbers.</p>
    </div>
  );
};

export default Bash_Grep;
